import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const printMembershipCardStyle = StyleSheet.create({
    printButtonStyle: {
        backgroundColor: appColors?.primary,
        borderRadius: 10
    },
    previewButtonStyle: {
        backgroundColor: appColors?.light,
        borderRadius: 10,
        borderWidth: 0.5,
        borderColor: appColors?.primary
    },
    buttonsOuterContainer: {
        alignItems: "center",
        justifyContent: "flex-end",
        flexDirection: "row",
        margin: 10,
    },
    outerContainer: {
        margin: 10,
        borderRadius: 10,
    },
    firstContainer: {
        width: "100%",
        paddingVertical: 10,
        borderRadius: 15,
        backgroundColor: appColors?.light
    },
    secondContainer: {
        paddingVertical: 10,
        borderRadius: 15
    },
    previewContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    cardOuterContainer: {
        justifyContent: "space-between",
        width: "100%"
    },
    cardInnerContainer: {
        borderRadius: 15,
        backgroundColor: appColors?.light,
        marginVertical: 10,
        overflow: "hidden",
        elevation: 5,
        shadowColor: "0000",
        shadowOpacity: 0.12,
        shadowRadius: 4,
        shadowOffset: { height: 2, width: 2 },

    },
    frontViewTextstyle: {
        alignItems: "center",
        backgroundColor: appColors?.primary
    },
    frontViewSecondConatiner: {
        paddingHorizontal: 15,
        paddingVertical: 20
    },
    customerCodeView: {
        flexDirection: "row",
        alignItems: "center"
    },
    badgeStyle: { backgroundColor: appColors?.badgeColor },
    badgeTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.light,
    },
    termsAndConditionTextStyle: {
        flexDirection: "row",
        alignItems: "center",
        paddingRight: 10
    },
})